(function () {
  'use strict';

  /* @ngdoc object
   * @name orders.list
   * @description
   *
   */
  angular
    .module('orders.list', [
      'ui.router'
    ]);
}());
